import styles from "./FormTitle.module.scss";

const FormTitle = ({ title, bgVariant = 'primary', headerStyle = "" }) => {
    return (
        <div className={`bg-${bgVariant} d-flex justify-content-center align-items-center p-3 p-md-4 ${styles.header} ${headerStyle}`}>
            <h1 className={`fw-normal text-center text-white mb-0 ${styles.heading}`}>{title}</h1>
        </div>
    )
}

export default FormTitle;
